/*
 * @Descripttion:
 * @version: 1.0
 * @Author: qiye
 * @Date: 2019-09-29 17:13:08
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2019-10-29 15:49:11
 */
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)


export default new Router({
  linkActiveClass: 'active',
  mode: 'history',
  base: '/cn/',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'index',
      component: ()=>import('@/components/index/index')
    },
    {
      path: '/adMachine',
      name: 'adMachine',
      component: ()=>import('@/components/landingPage/adMachine')
    },
    {
      path: '/touch',
      name: 'touch',
      component: ()=>import('@/components/landingPage/touch')
    },
    {
      path: '/horizontal',
      name: 'horizontal',
      component: ()=>import('@/components/landingPage/horizontal')
    },
    {
      path: '/upright',
      name: 'upright',
      component: ()=>import('@/components/landingPage/upright')
    },
    {
      path: '/vertical',
      name: 'vertical',
      component: ()=>import('@/components/landingPage/vertical')
    },
    {
      path: '/karol',
      name: 'karol',
      component: ()=>import('@/components/landingPage/karol')
    },
    {
      path: '/product',
      name: 'product',
      component: ()=>import('@/components/product/product')
    },
    {
      path: '/hardware/:id',
      name: 'hardware',
      component: ()=>import('@/components/hardware/hardware')
    },
    {
      path: '/touchquery',
      name: 'touchquery',
      component: ()=>import('@/components/touchQuery/touchQuery')
    },
    {
      path: '/program',
      name: 'program',
      component: ()=>import('@/components/program/program')
    },
    {
      path: '/retail',
      name: 'retail',
      component: ()=>import('@/components/retail/retail')
    },
    {
      path: '/caseshow',
      name: 'caseshow',
      component: ()=>import('@/components/caseShow/caseshow')
    },
    {
      path: '/caseshowlist/:id',
      name: 'caseShowList',
      component: ()=>import('@/components/caseShow/components/caseShowList')
    },
    {
      path: '/information',
      name: 'information',
      component: ()=>import('@/components/Information/Information')
    },
    {
      path: '/about',
      name: 'about',
      component: ()=>import('@/components/about/about'),
      meta:{
        title:'关于我们',
        content:{
          keywords:'多媒体信息发布系统,信息发布系统,触摸查询系统,触摸屏软件,排队叫号系统,导视系统,自助点餐系统,广告机软件,触控一体机软件,信息发布盒,明厨亮灶,云标物联',
          description:'云标物联：致力于多媒体智慧商显与屏幕软件应用,提供商显硬件及软件服务,多媒体信息发布系统,触摸查询系统,触摸屏软件,排队叫号系统,导视系统,自助点餐系统,自助售卖系统,信息发布盒,户外广告机,排队叫号机,明厨亮灶,百余行业的成功案例,上万商家的良好体验,服务热线:400-168-1191',
        }
      }
    },
   {
      path: '/service',
      name: 'service',
      component: ()=>import('@/components/service/service')
    },
    {
      path: '/news',
      name: 'news',
      component: ()=>import('@/components/news/news')
    },
    {
      path: '/aic1',
      name: 'aic1',
      component: ()=>import('@/components/AIProduct/aic1')
    },
    {
      path: '/aid1',
      name: 'aid1',
      component: ()=>import('@/components/AIProduct/aid1')
    },
    {
      path: '/aid2',
      name: 'aid2',
      component: ()=>import('@/components/AIProduct/aid2')
    },
    {
      path: '/aif1',
      name: 'aif1',
      component: ()=>import('@/components/AIProduct/aif1')
    },
    {
      path: '/aif2',
      name: 'aif2',
      component: ()=>import('@/components/AIProduct/aif2')
    },
    {
      path: '/aif3',
      name: 'aif3',
      component: ()=>import('@/components/AIProduct/aif3')
    },
    {
      path: '/ais1',
      name: 'ais1',
      component: ()=>import('@/components/AIProduct/ais1')
    },
    {
      path: '/ais2',
      name: 'ais2',
      component: ()=>import('@/components/AIProduct/ais2')
    },
    {
      path: '/programinfo/:id',
      name: 'programinfo',
      component: ()=>import('@/components/program/components/programInfo')
    },
    {
      path: '/office',
      name: 'office',
      component: ()=>import('@/components/landingPage/office')
    },
    {
      path: '/map',
      name: 'map',
      component: ()=>import('@/components/index/components/map')
    },
    {
      path: '/CloudShelf',
      name: 'CloudShelf',
      component: ()=>import('@/components/landingPage/CloudShelf')
    },
    {
      path: '/solution',
      name: 'solution',
      component: ()=>import('@/components/landingPage/solution')
    },
    {
      path: '/IntelligentMeeting',
      name: 'IntelligentMeeting',
      component: ()=>import('@/components/landingPage/IntelligentMeeting')
    },
    {
      path: '/SXTouch',
      name: 'SXTouch',
      component: ()=>import('@/components/landingPage/SXTouch')
    },
    {
      path: '/shangxian',
      name: 'shangxian',
      component: ()=>import('@/components/landingPage/shangxianServer')
    },
    {
      path: '/XFBox',
      name: 'XFBox',
      component: ()=>import('@/components/landingPage/XFBox')
    },
    {
      path:'/hflat',
      name:'hflat',
      component:()=>import('@/components/landingPage/seewo')
    },
    {
      path:'/learn',
      name:'learn',
      component:()=>import('@/components/landingPage/learn')
    },
    {
      path:'/selfhelp',
      name:'selfhelp',
      component:()=>import('@/components/landingPage/Self-help')
    },
    {
      path:'/thermometry',
      name:'thermometry',
      component:()=>import('@/components/landingPage/thermometry')
    },
    {
      path:'/expsoltion',
      name:'expsoltion',
      component:()=>import('@/components/landingPage/expsoltion')
    },
    {
      path:'/thermometryTwo',
      name:'thermometryTwo',
      component:()=>import('@/components/landingPage/thermometry-two')
    },
    // {
    //   path:'/partyBulding',
    //   name:'partyBulding',
    //   component:()=>import('@/components/partyBulding/partyBulding')
    // },
    {
      path:'/guide',
      name:'guide',
      component:()=>import('@/components/guide/guide')
    },
    {
      path:'/faceResolve',
      name:'faceResolve',
      component:()=>import('@/components/faceResolve/faceResolve')
    },
    {
      path:'*',
      redirect:'/'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js